<template>
    <div class="cg-detail" :key="renderCount">
        <div class="header">
            <!--            <span>Customer Detail - {{ clone.name }}</span>-->
            <span>{{ clone.description }}</span>
        </div>
        <div class="toolbar">
            <div class="left">
                <a-popover
                    :visible="columnModalVisible"
                    :overlayClassName="'no-padding'"
                    placement="bottom"
                    @visibleChange="changeColumnModalVisible"
                    trigger="click"
                >
                    <div slot="content">
                        <AddColumnForm
                            :on-cancelled="() => changeColumnModalVisible(false)"
                            :on-completed="addColumnToContacts"
                            :hidden-columns="getCols().map((x) => x.key)"
                        />
                    </div>

                    <a-button
                        type="primary"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :disabled="clone.contacts.length === 0"
                        :content="$t('wp.addColumnDesc')"
                    >
                        <a-icon type="plus" />
                        {{ $t("wp.addColumn") }}
                    </a-button>
                </a-popover>
                <a-button
                    type="primary"
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :content="$t('wp.addNewContactDesc')"
                    @click="openInsertMode"
                    :disabled="newContactMode"
                >
                    <a-icon type="plus" />
                    {{ $t("wp.addNewContact") }}
                </a-button>
                <a-button
                    type="primary"
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :content="$t('wp.importFileDesc')"
                    @click="selectFile"
                    :disabled="newContactMode"
                >
                    <a-icon type="import" />
                    {{ $t("wp.importFile") }}
                </a-button>
            </div>
            <div class="right">
                <a-button
                    type="primary"
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    content="Save changes"
                    :disabled="!isChanged() || updating"
                    @click="update"
                    :loading="updating"
                >
                    <a-icon type="save" />
                    {{ $t("wp.saveChanges") }}
                </a-button>
            </div>
        </div>
        <div
            id="wp-custom-group-number-input-validation"
            v-if="showRightWayOfTypingNumber"
            class="d-flex flex-column justify-content-center align-items-center text-center"
        >
            <div @mouseover="validInput = true" @mouseleave="validInput = false">
                <a-alert
                    message="Please make sure that you have typed the number correctly as showed below!"
                    type="info"
                    show-icon
                />
            </div>
            <div class="d-flex flex-row justify-content-center align-items-center text-center">
                <div class="m-2 p-2">
                    <a-alert message="Invalid" description="Don't start with plus (+) symbol!" type="error" show-icon />
                    <a-alert type="error" message="+905454443322" />
                </div>
                <div class="m-2 p-2">
                    <a-alert message="Invalid" description="Don't forget country code!" type="error" show-icon />
                    <a-alert type="error" message="05454443322" />
                </div>
                <div class="m-2 p-2" :class="{ 'valid-number-typing': validInput }">
                    <a-alert
                        message="Valid"
                        description="This is the single right way to typing number"
                        type="success"
                        show-icon
                    />
                    <a-alert message="905454443322" type="success" />
                </div>
            </div>
        </div>
        <a-table
            :columns="getCols()"
            :data-source="getFilteredRows()"
            :scroll="{ x: 800 }"
            size="small"
            :rowKey="`rowId`"
            :key="'table-' + renderCount"
            :rowClassName="getRowClassName"
            :pagination="pagination"
        >
            <div slot="number" slot-scope="text, record">
                <div v-if="record.new">
                    <a-input
                        @focus="showRightWayOfTypingNumber = true"
                        @blur="showRightWayOfTypingNumber = false"
                        :placeholder="$t('wp.number')"
                        v-model="singleContact['number']"
                    />
                </div>
                <span v-else-if="updatingContact && updatingContact.number === record.number">
                    <a-input :placeholder="$t('wp.number')" v-model="updatingContact.number" />
                </span>
                <span v-else>
                    {{ record.number.replace("@c.us", "") }}
                </span>
            </div>
            <template
                v-for="col of getCols().filter((x) => x.isCustom)"
                :slot="`renderSlot-${col.key}`"
                slot-scope="text, record"
            >
                <div v-if="record.new">
                    <a-input :placeholder="col.title" v-model="singleContact[col.key]" />
                </div>
                <span v-else-if="updatingContact && updatingContact.number === record.number">
                    <a-input :placeholder="col.title" v-model="updatingContact.attributes[col.key]" />
                </span>
                <span v-else>
                    {{ $_.isEmpty($_.get(record, col.key, "-")) ? "-" : $_.get(record, col.key, "-") }}
                </span>
            </template>
            <div slot="action" slot-scope="text, record">
                <div v-if="record.new">
                    <a-button type="danger" ghost @click="closeInsertMode" size="small">
                        {{ $t("wp.cancel") }}
                    </a-button>
                    <a-button type="primary" ghost @click="insertSingleContact" size="small">
                        {{ $t("wp.save") }}
                    </a-button>
                </div>
                <span v-else class="w-100">
                    <div v-if="!!updatingContact && updatingContact.number === record.number">
                        <a-button type="danger" ghost @click="cancelUpdatingContact" size="small">{{
                            $t("wp.cancel")
                        }}</a-button>
                        <a-button type="primary" ghost @click="saveUpdatingContact" size="small">
                            {{ $t("wp.save") }}</a-button
                        >
                    </div>

                    <div class="operation-buttons w-100" v-else>
                        <span
                            class="material-icons mx-2 text-primary operation-button"
                            @click="() => onEditContact(record)"
                        >
                            edit
                        </span>
                        <span @click="deleteContact(record)" class="material-icons mx-2 text-danger operation-button">
                            delete
                        </span>
                    </div>
                </span>
            </div>
            <div slot="indexSlot" slot-scope="text, record">
                <div v-if="record.new">
                    <span class="addIcon">
                        <a-icon type="plus" />
                    </span>
                </div>
                <span v-else> {{ text }} </span>
            </div>
        </a-table>
        <a-modal
            :visible="importFromFileMode"
            width="90vw"
            :footer="null"
            title=""
            @cancel="
                () => {
                    importFromFileMode = false;
                }
            "
        >
            <ImportContactsFromFile
                :on-completed="importCandidateFromFile"
                :on-cancelled="() => (importFromFileMode = false)"
                :required-attributes="getAddedAttributes()"
            />
        </a-modal>
        <Modal2
            v-if="saveChangesModalVisible"
            title="Değişiklikleri Kaydet"
            :showFooter="false"
            @cancel="cancelSaveChanges"
            @ok="cancelSaveChanges"
            className="save-changes-modal"
        >
            <div class="save-changes-modal-content">
                <p>
                    Eklediğiniz numaralarda Türkiye numaraları için otomatik düzeltme yapılsın mı? Otomatik düzeltme
                    özelliği, eğer numaralar 10 veya 11 haneli ise başına 9 veya 90 ekleyecektir.
                </p>
                <div class="save-changes-options">
                    <SupsisButton primary @click="saveChangesWithAutoFix">
                        Otomatik Düzeltme Uygulayarak Kaydet
                    </SupsisButton>
                    <SupsisButton ghost @click="saveChangesWithoutAutoFix"> Direkt Kaydet</SupsisButton>
                    <SupsisButton danger @click="cancelSaveChanges">Vazgeç</SupsisButton>
                </div>
            </div>
        </Modal2>
    </div>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../utils/log2";
import AddColumnForm from "../../components/AddColumnForm";
import WHATSAPP_API from "../../../../../api/whatsapp";
import ImportContactsFromFile from "./ImportContactsFromFile";
import Fuse from "fuse.js";
import { mapGetters, mapState } from "vuex";
import Modal2 from "../../../../../components/common/Modal2.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

const log = log2("CustomerGroupDetail");
export default {
    name: "CustomerGroupDetail",
    components: { AddColumnForm, ImportContactsFromFile, Modal2, SupsisButton },
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        searchTextOfSelected: {
            type: String,
            default: "",
        },
        channelId: {
            type: String,
        },
        isWhatsappBusiness: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            autoFixForTurkey: false,
            columnModalVisible: false,
            clone: _.cloneDeep(this.value),
            renderCount: 0,
            updating: false,
            newContactMode: false,
            validInput: false,
            updatingContact: null,
            singleContact: {
                number: "",
            },
            importFromFileMode: false,
            pagination: {
                defaultPageSize: 100,
                hideOnSinglePage: true,
                pageSizeOptions: ["10", "15", "20", "50", "100", "200"],
                showQuickJumper: true,
                showSizeChanger: true,
            },
            showRightWayOfTypingNumber: false,
            saveChangesModalVisible: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            initialized: (state) => state.whatsapp.info.initialized,
            status: (state) => state.whatsapp.info.status,
            whatsappPlusEnabled: (state) => _.get(state.setting.settings, "whatsapp.plus.enabled", false),
        }),
    },
    methods: {
        openNotificationWithIcon(featureType, type = "warning") {
            const messages = {
                import: {
                    message: "Whatsapp Plus Plan Required.",
                    description:
                        "Importing contacts is not available in your plan. Please upgrade your plan to import contacts.",
                },
                addColumn: {
                    message: "Whatsapp Plus Plan Required.",
                    description:
                        "Adding columns is not available in your plan. Please upgrade your plan to add columns.",
                },
            };
            const message = messages[featureType];
            const key = `plan`;
            this.$notification[type]({
                message: message.message,
                description: message.description,
                placement: "topRight",
                key,
                btn: (h) => {
                    return h(
                        "a-button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    log("clicked", this.$notification);
                                    this.$router.push("/settings/billing");
                                    this.$notification.close(key);
                                },
                            },
                        },
                        "Change Plan"
                    );
                },
            });
        },
        importCandidateFromFile(contacts, autoFixForTurkey) {
            if (Array.isArray(contacts) && !_.isEmpty(contacts)) {
                const oldAttributes = this.getAddedAttributes();
                const newAttributes = _.difference(Object.keys(contacts[0].attributes), oldAttributes);
                log("newAttributes", newAttributes);
                if (newAttributes.length) {
                    this.autoFixForTurkey = autoFixForTurkey;
                    this.clone.contacts = [
                        ...this.clone.contacts.map((x) => ({
                            ...x,
                            attributes: {
                                ...x.attributes,
                                ...newAttributes.reduce(
                                    (acc, cur) => ({
                                        ...acc,
                                        [cur]: "",
                                    }),
                                    {}
                                ),
                            },
                        })),
                        ...contacts,
                    ];
                } else {
                    this.clone.contacts = this.clone.contacts.concat(contacts);
                }

                this.importFromFileMode = false;

                this.$message.success("Contacts Imported successfully");
            }
        },
        selectFile() {
            if (!this.channelId && !this.whatsappPlusEnabled) {
                this.openNotificationWithIcon("import");
                return;
            }
            this.importFromFileMode = true;
        },
        getRowClassName(record, index) {
            const classList = ["contact-row"];
            if (record.new) classList.push("new");
            if (this.updatingContact && this.updatingContact.number === record.number) classList.push("updating");
            if (index % 2 === 0) classList.push("even");
            return classList.join(" ");
        },
        cancelUpdatingContact() {
            this.updatingContact = null;
        },
        saveUpdatingContact() {
            this.clone.contacts = this.clone.contacts.map((x) => {
                if (x.number === this.updatingContact.number) {
                    return this.updatingContact;
                }
                return x;
            });
            this.updatingContact = null;
            this.renderCount++;
        },
        deleteContact(contact) {
            this.clone.contacts = this.clone.contacts.filter((x) => x.number !== contact.number);
            log("deleteContact", {
                contact,
                isChanged: _.isEqual(this.clone, this.value),
            });
            this.renderCount++;
        },
        onEditContact(item) {
            this.updatingContact = this.clone.contacts.find((x) => x.number === item.number);
        },
        // showConfirmDeleteContact(item) {
        //     this.$confirm({
        //         title: `Are you sure delete this customer group? (${record.name})`,
        //         onOk: () => {
        //             this.deleteCustomerGroup(record._id);
        //             if (this.onRowDeleted) this.onRowDeleted(record);
        //         },
        //         onCancel() {},
        //     });
        // },
        openInsertMode() {
            const contacts = this.clone.contacts;
            const firstContact = contacts[0];
            let cols = Object.keys(_.get(firstContact, "attributes", {}));
            this.singleContact = {
                number: "",
                ...cols.reduce((acc, col) => {
                    acc[col] = "";
                    return acc;
                }, {}),
            };
            this.newContactMode = true;
        },
        closeInsertMode() {
            this.newContactMode = false;
            this.singleContact = {
                number: "",
            };
        },
        insertSingleContact() {
            this.clone.contacts.push({
                number: this.singleContact.number,
                attributes: _.omit(this.singleContact, ["number"]),
            });
            this.newContactMode = false;
            this.$message.success(this.$t("wp.contactAdded"));
        },
        isChanged() {
            log("isChanged", !_.isEqual(this.value, this.clone));
            return !_.isEqual(this.value, this.clone);
        },
        update() {
            this.saveChangesModalVisible = true;
        },
        saveChangesWithAutoFix() {
            this.autoFixForTurkey = true;
            this.saveChanges(true);
        },
        saveChangesWithoutAutoFix() {
            this.autoFixForTurkey = false;
            this.saveChanges(false);
        },
        cancelSaveChanges() {
            this.saveChangesModalVisible = false;
        },
        saveChanges(autoFixForTurkey) {
            this.updating = true;
            const hide = this.$message.loading(this.$t("wp.updateCustomerGroup"), 0);
            WHATSAPP_API.BROADCAST.updateGroup(
                this.clone._id,
                this.clone.name,
                this.clone.description,
                this.clone.contacts,
                this.isWhatsappBusiness,
                autoFixForTurkey
            )
                .then((res) => {
                    this.$message.success(this.$t("wp.updateCustomerGroupSuccess"));
                    this.$emit("input", _.cloneDeep(this.clone));
                    this.newContactMode = false;
                    this.updatingContact = undefined;
                })
                .finally(() => {
                    hide();
                    this.updating = false;
                    this.saveChangesModalVisible = false;
                });
        },

        addColumnToContacts(colName, defaultValue) {
            log("addColumnToContacts", { colName, defaultValue });
            this.clone.contacts = this.clone.contacts.map((x) => {
                if (!x.attributes) x["attributes"] = {};
                x.attributes[colName] = defaultValue;
                return x;
            });
            this.columnModalVisible = false;
            this.clone = _.cloneDeep(this.clone);
            this.$nextTick(() => {
                this.renderCount++;
            });
        },
        changeColumnModalVisible(visible) {
            if (visible && !this.channelId && !this.whatsappPlusEnabled) {
                this.openNotificationWithIcon("addColumn");
                return;
            }
            this.columnModalVisible = visible;
        },
        addColumn() {},
        getCols() {
            const firstContact = this.clone.contacts[0];

            let cols = _.isEmpty(firstContact) ? [] : Object.keys(_.get(firstContact, "attributes", {}));

            cols = [
                {
                    title: "#",
                    width: 50,
                    dataIndex: "index",
                    key: "index",
                    // fixed: "left",
                    scopedSlots: { customRender: `indexSlot` },
                },
                {
                    title: this.$t("wp.number"),
                    width: 200,
                    dataIndex: "number",
                    key: "number",
                    // fixed: "left",
                    scopedSlots: { customRender: `number` },
                },

                ...cols.map((col) => ({
                    title: col.toUpperCase(),
                    dataIndex: col,
                    key: col,
                    scopedSlots: { customRender: `renderSlot-${col}` },
                    isCustom: true,
                })),
                {
                    title: this.$t("wp.actions"),
                    key: "actions",
                    // fixed: "right",
                    width: 200,
                    scopedSlots: { customRender: "action" },
                },
            ];
            // log("cols", cols);
            return cols;
        },
        getRows() {
            const contacts = this.clone.contacts;
            const firstContact = contacts[0];
            let cols = _.isEmpty(firstContact) ? [] : Object.keys(_.get(firstContact, "attributes", {}));
            let rows = contacts.map((contact, index) => ({
                ...cols.reduce((acc, col) => {
                    acc[col] = _.get(contact, ["attributes", col], "");
                    return acc;
                }, {}),
                index: index + 1,
                number: contact.number,
                rowId: `${contact.number}-${index}`,
            }));
            if (this.newContactMode) {
                rows = [
                    {
                        _id: "new",
                        rowId: "new",
                        ...cols.reduce((acc, col) => {
                            acc[col] = "";
                            return acc;
                        }, {}),
                        index: rows.length + 1,
                        number: "",
                        new: true,
                    },
                    ...rows,
                ];
            }
            log("rows", rows, this.clone.contacts);
            return rows;
        },
        getFilteredRows() {
            const searchingFields = !!this.getRows().length ? Object.keys(this.getRows()[0]) : ["number"];
            let fuzzySearch = new Fuse(this.getRows(), { keys: searchingFields, threshold: 0.4 });
            const filteredRows =
                this.searchTextOfSelected.length > 0
                    ? fuzzySearch.search(this.searchTextOfSelected).map((x) => x.item)
                    : this.getRows();
            log("filteredRow", filteredRows);
            return filteredRows;
        },
        getAddedAttributes() {
            const firstContact = (this.clone.contacts || this.clone.numbers)[0];
            const cols = _.isEmpty(firstContact) ? [] : Object.keys(_.get(firstContact, "attributes", {}));
            return cols;
        },
    },
    mounted() {
        log("mounted", this.clone);
    },
    watch: {
        value: {
            handler(val) {
                if (!_.isEqual(val, this.clone)) {
                    log("watch value", val);
                    this.clone = _.cloneDeep(val);
                    this.renderCount++;
                }
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.cg-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;

    #wp-custom-group-number-input-validation {
        .ant-alert-with-description {
            padding: 5px 15px 5px 60px;
        }

        .ant-alert-error,
        .ant-alert-success {
            border: none !important;
        }

        .valid-number-typing {
            border: 2px solid #53c553;
            border-radius: 4px;
        }
    }

    .header {
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: flex-start;
    }

    .ant-table-thead {
        th {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .contact-row {
        &.even {
            background-color: #f5f5f5;
        }

        &.new {
            background-color: #e0f3fa;
        }

        &.updating {
            background-color: #e0f3fa;
        }

        td {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .addIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        cursor: pointer;
        background-color: #8bc34a;
        color: white;
    }

    .toolbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: sticky;
        top: 40px;
        z-index: 20;
        background: white;
    }

    .operation-buttons {
        display: flex;
        gap: 5px;
        cursor: pointer;

        .operation-button {
            cursor: pointer;
        }

        &.hidden {
            .operation-button {
                display: none;
            }
        }
    }
}
</style>
<style>
.save-changes-modal {
    .ant-modal {
        width: 600px !important;
    }

    .ant-modal-body {
        padding: 20px 40px;
    }

    .save-changes-modal-content {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .save-changes-options {
            display: flex;
            gap: 10px;
            justify-content: flex-end;
        }
    }
}
</style>
